module.exports = __webpack_public_path__ + "01f43047/img/grid-web-icon.d0395d64.svg";